module.exports = __webpack_public_path__ + "img/Kaylee-Ho.e013c8e8.jpg";